import {
  initializeMenuCheckout,
  addToCartWhenClick,
  disableButtonWhenItemIsOnCart
} from './cart';
import menuHamburger from './menuHamburger';
import toggleMenu from './toggleMenu';
import setupSubmitOnEnter from './submit';

const HeaderModule = () => {
  // Header
  menuHamburger();
  toggleMenu();
  initializeMenuCheckout();
  addToCartWhenClick();
  setupSubmitOnEnter();
  disableButtonWhenItemIsOnCart();
};
export default HeaderModule;



// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/app/assets/javascripts/packs/common/header.js